module.exports = __webpack_public_path__ + "img/ivana-squares.cdb4db6e.jpg";